import React from 'react';
import { Link } from 'react-router-dom';
import './NotFoundPage.css';

interface NotFoundPageProps {
  type?: '404' | '403';
}

const NotFoundPage: React.FC<NotFoundPageProps> = ({ type = '404' }) => {
  const content = {
    '404': {
      code: '404',
      title: 'Page Not Found',
      message: 'The page you\'re looking for doesn\'t exist.'
    },
    '403': {
      code: '403',
      title: 'Access Denied',
      message: 'You don\'t have permission to access this page.'
    }
  };

  const currentContent = content[type];

  return (
    <div className="not-found-page">
      <div className="not-found-container">
        <div className="not-found-content">
          <h1>{currentContent.code}</h1>
          <h2>{currentContent.title}</h2>
          <p>{currentContent.message}</p>
          <Link to="/" className="home-button">
            Go Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;